// import React, { useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
//   Typography,
//   IconButton,
//   Box,
//   Grid,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import CustomDataGrid from '../../../../../components/CustomDataGrid/CustomDataGrid.tsx';

// function AddSubOptionDialog(props) {
//   const { open,onClose, onSave } = props;

//   const [nameOption, setNameOption] = useState('');
//   const [priceOption, setPriceOption] = useState('');

//   const handleClose = () => {
//     onClose();
//   };

// //   const handleSave = () => {
// //     const option = {
// //       name: nameOption,
// //       price: priceOption,
// //     };
// //     onSave(option);
// //     onClose();
// //   };

//   const handleNameChange = (event) => {
//     setNameOption(event.target.value);
//   };

//   const handlePriceChange = (event) => {
//     setPriceOption(event.target.value);
//   };

//   //table start

//   const [sectionItemsToggle, setsectionItemsToggle] = React.useState(false);
//   const [sectionItemsdialogType, setsectionItemsdialogType] = React.useState("");
//   const onHandlesectionItems = () => {
//     setsectionItemsToggle(false);
//   }

//   const columnsdatas = [
//     {
//         field: 'rank', headerName: ' Rank', renderCell: (params) => <div>
//           <span onClick={() => { setsectionItemsToggle(true); setsectionItemsdialogType(params.value) }} style={{ color: "blue", cursor: "pointer" }}>{params.value}</span>
//         </div>, flex: 1
//       },
//     {
//       field: 'name', headerName: ' Name', renderCell: (params) => <div>
//         <span onClick={() => { setsectionItemsToggle(true); setsectionItemsdialogType(params.value) }} style={{ color: "blue", cursor: "pointer" }}>{params.value}</span>
//       </div>, flex: 1
//     },
//     {
//       field: 'price',
//       headerName: 'Price',
//       renderCell: (params) => <div>{params.value}</div>, flex: 1
//     },
//   ];

//   const dataRows = [
//     { id: 1,rank:1, name: 'Standard', price: '10$' },
//     { id: 2,rank:2, name: 'Special', price: '20$' },
//     { id: 3,rank:3, name: 'Shop', price: '50$' },
    
//   ];

//   const [selectedDataRows, setSelectedDatarows] = React.useState([]);
//   const [selectedDataRowsCount, setSelectedDatarowsCount] = React.useState([]);
//   const [countSelectedDatas, setcountSelectedDatas] = React.useState(0);
//   const [value, setValue] = React.useState('1')

//   const getselectedData = (props) => {
//     console.log("props: " + props);
//     if (selectedDataRows[value] === undefined) {
//       selectedDataRows[value] = [];
//       selectedDataRowsCount[value] = [];
//     }
//     selectedDataRows[value] = props;
//     selectedDataRowsCount[value] = props.length;
//     setSelectedDatarowsCount(selectedDataRowsCount);
//     console.log("selectedDataRows[value]: " + selectedDataRows[value]);
//     setSelectedDatarows(selectedDataRows);
//     setcountSelectedDatas(props.length);
//   }

//   //table end

//   return (
//     <Dialog open={open}  className="specificationDialog specificationOptionDialog">
//       <DialogTitle disableTypography>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="h6" className="textColor">
//             Add Option
//           </Typography>
//           <IconButton aria-label="close" className="closeButton" onClick={handleClose}>
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>
//       <DialogContent className="textColor">
//         <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
//           <Grid item xs={2}>
//             <Typography className="textColor">Name</Typography>
//           </Grid>
//           <Grid item xs={10}>
//             <TextField
//               label="Name"
//               value={nameOption}
//               onChange={handleNameChange}
//               fullWidth
//               margin="normal"
//               InputLabelProps={{ sx: { color: '#371B17' } }}
//             />
//           </Grid>
//           <Grid item xs={2}>
//             <Typography className="textColor">Price</Typography>
//           </Grid>
//           <Grid item xs={10}>
//             <TextField
//               label="Price"
//               value={priceOption}
//               onChange={handlePriceChange}
//               fullWidth
//               margin="normal"
//               InputLabelProps={{ sx: { color: '#371B17' } }}
//             />
          
//           </Grid>
//         </Grid>
//         {
//               selectedDataRows[value] != undefined ? <CustomDataGrid columns={columnsdatas} dataRows={dataRows} getselectedData={getselectedData} selectedRows={selectedDataRows[value]} /> : <CustomDataGrid columns={columnsdatas} dataRows={dataRows} getselectedData={getselectedData} />
//             }
//       </DialogContent>
//       <DialogActions>
//         <Button  className="textColor btn">
//           Save
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// export default AddSubOptionDialog;




import React, { useState } from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Typography from '@mui/material/Typography'

import Cancel from './../../../../../../assets/icons/close.png'
import itemImg from './../../../../../../assets/icons/inventory.png'
import scheduleImg from './../../../../../../assets/icons/schedule.png'
import binImg from './../../../../../../assets/icons/recycle-binColor.png'

import SchedulerComponent from '../../SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx';
import AutoCompleteMultiSelect from '../../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';

import CustomDataGrid from '../../../../../components/CustomDataGrid/CustomDataGrid.tsx';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import TextAreaComponents from '../../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import AddItemDialogComponent from '../../../AddItemDialog.tsx';
import InventoryScheduleDialog from '../../../InventoryView/InventoryDialog/InventoryScheduleDialog/InventoryScheduleDialog.tsx';
import { toast } from 'react-toastify';
import axios from 'axios';
import SweetAlertModal from '../../../../../components/SweetAlertModal/SweetAlertModal';


function AddSubOptionDialog(props) {
    const apiAddress = process.env.REACT_APP_SECRET;
    const Restauranttoken =JSON.parse(localStorage.getItem('restaurant'));
    const [openConfirmaitonModal, setopenConfirmaitonModal]=useState(false)
    const [nameErr, setNameErr]=useState(false)
    const [priceErr , setPricErr]=useState(false)
    console.log(Restauranttoken)
    const handleClose = () => {
        props.onClose(false)
        props.reloadSuboption()
    }
    const [price, setPrice] = React.useState();
    const textFieldValue = (props) => {
        console.log(props)
        setPrice(props)
        setPricErr(false)
    }
    const itemdata = [
        { id: 1, title: 'Chicken' },
        { id: 2, title: 'Burger' },
        { id: 3, title: 'Curry' },
        { id: 4, title: 'Soup' },
        { id: 5, title: 'Fries' },
    ]
    const [name, setNtem] = React.useState('');
    const addValue = (props) => {
        console.log(props)
        setNtem(props)
        setNameErr(false)
    }
    const [open, setOpen] = React.useState(false)
    const handleClickOpen = () => {
        setOpen(true)
    }
    const handleAddItem = (AddItemData) => {
        setOpen(AddItemData)
    }

    const [scheduleopen, setScheduleOpen] = React.useState(false)
    const handleClickScheduleOpen = () => {
        setScheduleOpen(true)
    }
    const handleAddSchedule = (props) => {
        console.log("props: " + props);
        setScheduleOpen(false);

        var data = dataRows;

        selectedDataRows.map((d, index) => {
            console.log("Data: " + d.item);
            var l = data.find(x => x.id == d.id);
            var i = data.indexOf(l);
            data[i].schedule = props;
        })
        settempDatarows(data);
        setDatarows([]);
    }


    const columns = [

        { field: 'name', headerName: 'Name', flex: 1 },
        { field: 'price', headerName: 'Price', flex: 1 },
        // { field: 'schedule', headerName: 'Schedule', flex: 1 }
    ];

    const [selectedDataRows, setSelectedDatarows] = React.useState([]);
    const getselectedData = (props) => {
        console.log("props: " + props);
        setSelectedDatarows(props);
    }


    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 320,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));


    const [dataRows, setDatarows] = React.useState([]);
    const [tempdataRows, settempDatarows] = React.useState([]);


    React.useEffect(() => {
        setDatarows(tempdataRows);
    }, [dataRows])

    var data = dataRows;
    console.log(data)
    
    const PostSubOptionToApi=async(data)=>{
        var  url = apiAddress + "/api/AddOnSubOptionsMaster/CreateAddOnSubOptionsMaster"
        var res
      await  axios
        .post(url, data)
        .then((response) => {
            console.log(response.data);
            res=response.data
            toast.success("Successfully Saved", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            
        });
        return response.data
        })
        .catch((error)=>{
            console.log(error)
            toast.error("failed", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        })
 return res
    }
    const addData =async () => {
        setopenConfirmaitonModal(false)
        var valid =true
        if(!!name==false){
            setNameErr(true)
            valid=false
        }
        if(!!price==false){
            setPricErr(true)
            valid=false
        }
        if(valid){
        var apiData={
            id: "string",
            RestaurantId:Restauranttoken.id,
            subOptionName: name,
            price: price,
            creationId: "string",
            modificationId: "string"
          }
          var returnData= await PostSubOptionToApi(apiData)
        console.log(returnData)

        var data = [...dataRows];

        var obj = {
            // id: data.length,
            id:returnData.id,
            name: name,
            price: price,
          
        }
        data.push(obj);
        settempDatarows(data);

        setDatarows([]);
        setNtem('')
        setPrice('')
    }
    }
    const handleClickRemoveOpen = () => {
        var data = dataRows;

        selectedDataRows.map((d, index) => {
            console.log("Data: " + d.item);
            var l = data.find(x => x.id == d.id);
            var i = data.indexOf(l);
            data = data.slice(i, 1);
        })
        settempDatarows(data);
        setDatarows([]);
    }

    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                     <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to save this?"} open={openConfirmaitonModal} onyes={addData} close={() => { setopenConfirmaitonModal(false) }} />
                    <Grid container>
                        <Grid item xs={8}>
                            <DialogTitle>
                                <div className='d-flex' style={{ gap: "8px" }}>
                                    {/* <div>
                                        <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                                    </div> */}

                                    <span style={{ color: "#2a7fd4" }}>Add sub option</span>
                                </div>
                            </DialogTitle>
                        </Grid>
                        <Grid item xs={4}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Name
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                          
                              <TextAreaComponents label={'Name'} value={addValue}  val={name}/>
                              {nameErr && <span style={{color:'red'}}>This field is required</span>}
                        </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Price
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <TextAreaComponents label={'Price'} value={textFieldValue} val={price} id={2} />
                                {priceErr && <span style={{color:'red'}}>This field is required</span>}
                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <div className='d-flex justify-content-center'>
                                    <button className='btn btn-success' onClick={() => { setopenConfirmaitonModal(true) }}>Add</button>
                                </div>

                            </Grid>
                        </Grid>
                        {/* <Grid container>
                            <Grid item xs={12} style={{ paddingTop: '1rem' }}>
                                <div className='d-flex'>
                                    <div>
                                        <div className={`${selectedDataRows.length === 0 ? "" : "d-none"}`}
                                            style={{ filter: "contrast(.5)", }}>
                                            <HtmlTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Typography color="inherit">Please Select Items From The Table</Typography>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button>
                                                    <div className='d-flex ' style={{ gap: "10px" }}>
                                                        <div className='roundedCorner' style={{ cursor: "pointer" }}>
                                                            <img src={scheduleImg} alt='' style={{ width: "1.2rem" }} />
                                                            Apply schedule
                                                        </div>

                                                    </div>
                                                </Button>

                                            </HtmlTooltip>
                                        </div>

                                        <div className={`${selectedDataRows.length > 0 ? "" : "d-none"}`}>
                                            <Button onClick={() => { handleClickScheduleOpen() }}>
                                                <div className='d-flex ' style={{ gap: "10px" }}>
                                                    <div className='roundedCorner' style={{ cursor: "pointer" }}>
                                                        <img src={scheduleImg} alt='' style={{ width: "1.2rem" }} />
                                                        Apply schedule
                                                    </div>

                                                </div>
                                            </Button>
                                        </div>
                                    </div>
                                    <div>
                                        <div className={`${selectedDataRows.length === 0 ? "" : "d-none"}`}
                                            style={{ filter: "contrast(.5)", }}>
                                            <HtmlTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Typography color="inherit">Please Select Items From The Table</Typography>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button>
                                                    <div className='d-flex ' style={{ gap: "10px" }}>
                                                        <div className='roundedCorner' style={{ cursor: "pointer" }}>
                                                            <img src={binImg} alt='' style={{ width: "1.2rem" }} />

                                                        </div>

                                                    </div>
                                                </Button>

                                            </HtmlTooltip>
                                        </div>

                                        <div className={`${selectedDataRows.length > 0 ? "" : "d-none"}`}>
                                            <Button onClick={() => { handleClickRemoveOpen() }}>
                                                <div className='d-flex ' style={{ gap: "10px" }}>
                                                    <div className='roundedCorner' style={{ cursor: "pointer" }}>
                                                        <img src={binImg} alt='' style={{ width: "1.2rem" }} />
                                                    </div>

                                                </div>
                                            </Button>
                                        </div>
                                    </div>
                                </div>


                            </Grid>
                        </Grid> */}

                        <Grid container>
                            <Grid item xs={12} style={{ paddingTop: '1rem' }}>
                                <CustomDataGrid columns={columns} dataRows={dataRows} getselectedData={getselectedData} />
                            </Grid>
                        </Grid>


                        

                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <Button className="">Save</Button>
                            </Grid>
                        </Grid>

                    </DialogContent>
                   
                </Dialog>
            </React.Fragment>
            <AddItemDialogComponent
                open={open}
                onHandleAddItem={handleAddItem}
                title={props.title}
            />
            <InventoryScheduleDialog
                open={scheduleopen}
                onHandleAddItem={handleAddSchedule}
                title={props.title}
            />
        </div>
    );
}

export default AddSubOptionDialog;